const SHOW_FULLSCREEN_VIEW = "page::fullscreen-view::show";
const HIDE_FULLSCREEN_VIEW = "page::fullscreen-view::hide";

function showFullscreenViewAction(url, mediaType, filename) {
  const payload = {
    url,
    filename,
    mediaType,
  };

  return {
    payload,
    type: SHOW_FULLSCREEN_VIEW,
  };
}

const hideFullscreenViewAction = {
  payload: {
    url: null,
    filename: null,
    mediaType: null,
  },
  type: HIDE_FULLSCREEN_VIEW,
};

export {
  SHOW_FULLSCREEN_VIEW,
  HIDE_FULLSCREEN_VIEW,
  showFullscreenViewAction,
  hideFullscreenViewAction,
};
